import { useTranslation } from 'react-i18next';
import type { OpenAccountResponseDto } from '../api/types';
import { CopyField } from '@/shared/components';
import { useMemo } from 'react';

type Props = {
  openAccountData: OpenAccountResponseDto;
};

const ALLOWED_KEYS: Array<keyof OpenAccountResponseDto> = [
  'tradingAccountKey',
  'password',
  'tradingPlatformName',
  'email',
];

const OpenAccountResultDetails = ({ openAccountData }: Props) => {
  const { t } = useTranslation();

  const accountDetails = useMemo(() => {
    return (Object.keys(openAccountData) as Array<keyof OpenAccountResponseDto>)
      .filter(key => ALLOWED_KEYS.includes(key))
      .map(key => {
        return {
          text: t(`openAccount.params.${key}`),
          value: openAccountData[key] ?? '',
        };
      });
  }, [openAccountData]);

  return (
    <div className="flex flex-col gap-[2.4rem] px-[2.4rem] py-[1.6rem] bg-muted rounded-[1.6rem] mt-[6.4rem] mb-[3.2rem] w-full">
      {accountDetails.map(detail => (
        <div className="flex flex-col gap-[0.2rem]" key={detail.text}>
          <label className="p4 text-muted-foreground">{detail.text}</label>
          <CopyField value={detail.value?.toString()} variant="compact" />
        </div>
      ))}
    </div>
  );
};

export { OpenAccountResultDetails };
